/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('SalesFilterEventTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		SalesFilterEventTypeFactory,
		FindAllSalesFilterEventTypesByQueryParamsFactory,
		NoPagingSalesFilterEventTypeFactory,
		NoPagingSalesFilterFactory,
		NoPagingEventTypeFactory
	) {
		$scope.salesFilterEventTypeList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeSalesFilterEventType)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeSalesFilterEventType);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltereventtype.list.new');
		};

		$scope.goToEditState = function(salesFilterEventType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('salesfiltereventtype.list.edit', { salesFilterEventTypeId: salesFilterEventType.id });
		};

		var getSalesFilterId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.salesFilter)) {
				return $scope.SalesFilterEventTypeSearchOverview.salesFilter.id;
			} else {
				return undefined;
			}
		};

		var getEventTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.SalesFilterEventTypeSearchOverview.eventType)) {
				return $scope.SalesFilterEventTypeSearchOverview.eventType.id;
			} else {
				return undefined;
			}
		};

		/**
		 * This function queries all entities of type SalesFilter and checks if this SalesFilterEventType dialog is called in the context of SalesFilter.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.querySalesFilter = function() {
			return NoPagingSalesFilterFactory.query(function(result) {
				return result;
			});
		};
		$scope.salesFilterReferenceFilterList = $scope.querySalesFilter();

		/**
		 * This function queries all entities of type EventType and checks if this SalesFilterEventType dialog is called in the context of EventType.
		 * If this is the case, we detect the parent entity SalesFilterEventType and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryEventType = function() {
			return NoPagingEventTypeFactory.query(function(result) {
				return result;
			});
		};
		$scope.eventTypeReferenceFilterList = $scope.queryEventType();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.SalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeSalesFilterEventType = angular.copy($scope.pageSize);

			FindAllSalesFilterEventTypesByQueryParamsFactory.query(
				{
					page: $scope.SalesFilterEventTypeSearchOverview.page - 1,
					size: $scope.pageSize,
					salesFilterId: getSalesFilterId(),
					eventTypeId: getEventTypeId(),

					sort: [
						$scope.SalesFilterEventTypeSearchOverview.predicate +
							',' +
							($scope.SalesFilterEventTypeSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.salesFilterEventTypeList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isSalesFilterEventTypeSearchOverviewDirty = function() {
			return !angular.equals($scope.SalesFilterEventTypeSearchOverview, $scope.originalSalesFilterEventTypeSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.SalesFilterEventTypeSearchOverview = {};
			$rootScope.SalesFilterEventTypeSearchOverview.page = 1;
			$rootScope.SalesFilterEventTypeSearchOverview.predicate = 'id';
			$rootScope.SalesFilterEventTypeSearchOverview.ascending = false;

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);

			$scope.originalSalesFilterEventTypeSearchOverview = angular.copy($scope.SalesFilterEventTypeSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.SalesFilterEventTypeSearchOverview) || $rootScope.SalesFilterEventTypeSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.SalesFilterEventTypeSearchOverview = angular.copy($rootScope.SalesFilterEventTypeSearchOverview);
			$scope.search();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.SalesFilterEventTypeSearchOverview.predicate === itemName) {
				if ($scope.SalesFilterEventTypeSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
